import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a581dbdc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&lang=css&external"
import style1 from "./index.vue?vue&type=style&index=1&id=a581dbdc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a581dbdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\01_Projects\\zr_code\\exam_registration_api\\exam-registration-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a581dbdc')) {
      api.createRecord('a581dbdc', component.options)
    } else {
      api.reload('a581dbdc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a581dbdc&scoped=true", function () {
      api.rerender('a581dbdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/base-ui/ds-form/src/index.vue"
export default component.exports